import { render, staticRenderFns } from "./VTab.vue?vue&type=template&id=c8b44af8&scoped=true&"
import script from "./VTab.vue?vue&type=script&lang=js&"
export * from "./VTab.vue?vue&type=script&lang=js&"
import style0 from "./VTab.vue?vue&type=style&index=0&id=c8b44af8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b44af8",
  null
  
)

export default component.exports